import React from "react";
import { UI } from "@wwimmo/ui";
import styles from "./AssemblyRealestateListRow.module.css";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { AssemblyRealestate } from "src/stores/assemblies/AssemblyStore";

const AssemblyRealestateListRowDesktopBase = (props: {
    assemblyrealestate: AssemblyRealestate;
    onRemoveRealestate: any;
    widths: number[];
    isAssemblyReadOnly?: boolean;
}) => {
    const { realestate, isReadOnly } = props.assemblyrealestate;
    const { widths, onRemoveRealestate, isAssemblyReadOnly } = props;

    if (realestate === undefined) {
        return <div>/</div>;
    }

    const formatAddress =
        realestate.houses !== undefined && realestate.houses.length > 0
            ? `${
                  realestate.houses[0].street && realestate.houses[0].housenumber
                      ? `${realestate.houses[0].street} ${realestate.houses[0].housenumber}`
                      : ""
              }
     ${
         realestate.houses[0].street &&
         realestate.houses[0].housenumber &&
         realestate.houses[0].zip &&
         realestate.houses[0].city
             ? ", "
             : ""
     }
     ${
         realestate.houses[0].zip && realestate.houses[0].city
             ? `${realestate.houses[0].zip} ${realestate.houses[0].city}`
             : ""
     }`
            : "";

    return (
        <UI.List.Row className={styles.AssemblyRealestateRowMobileListRow} key={realestate.id}>
            <UI.List.Cell
                className={
                    realestate.consolidationid === null || realestate.consolidationid === ""
                        ? undefined
                        : styles.ChildItemNameIT2
                }
                colspan={widths[0]}
                value={realestate.name}
                truncate
            />
            <UI.List.Cell
                className={
                    realestate.consolidationid === null || realestate.consolidationid === ""
                        ? undefined
                        : styles.ChildItemNumberIT2
                }
                colspan={widths[1]}
                value={realestate.number}
                truncate
            />
            <UI.List.Cell value={formatAddress} colspan={widths[2]} />
            <UI.List.Cell
                key={"c-1"}
                colspan={widths[3]}
                value={
                    isReadOnly || isAssemblyReadOnly ? undefined : (
                        <UI.Icon
                            icon={UI.SVGIcon.Trash}
                            onClick={onRemoveRealestate(realestate.id)}
                            className={styles.TrashIcon}
                        />
                    )
                }
                className="d-flex justify-content-center"
            />
        </UI.List.Row>
    );
};

export const AssemblyRealestateListRowDesktop = Sentry.withProfiler(observer(AssemblyRealestateListRowDesktopBase));
